import React from 'react';

export default function MemoryCell({ memory }: { memory: number | string }) {
	return <div>{memory}MB</div>;
}
